import React, {useContext, useEffect, useState} from 'react'
import ListItem from "../common/ListItem";
import ListGroup from "../common/ListGroup";
import axios from "../common/axios";
import CircularLoader from "../common/CircularLoader";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import {NavigationContext} from "../common/NavigationContext";

const MessagesNavigation = () => {
    const [unreadMessages, setUnreadMessages] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const { loadShortcutByUrl } = useCurrentShortcut();
    const { setNavVisible } = useContext(NavigationContext);

    const getUserMessages = () => {
        axios.get('/web/ui/message/userMessagesInbox',  {params: {pageNumber: 1, pageSize: 20, mailbox: 'INBOX'}})
            .then(response => {
                setUnreadMessages(response.data.currPageContents.filter(message => !message.read));
                setLoading(false);
            });
    }

    useEffect(() => {
        getUserMessages();
    }, []);

    const handleClick = () => {
        const shortcutUrl = '/web/ui/view/messages';
        loadShortcutByUrl(shortcutUrl);
        setNavVisible(false);

        if (globalReactFunctions && globalReactFunctions.handleTitleNavMenuClose) {
            globalReactFunctions.handleTitleNavMenuClose();
        }
    }

    if (isLoading) {
        return <CircularLoader pageCentered={false}/>
    }

    if (unreadMessages.length === 0) {
        return null;
    }

    return (
        <ListGroup id={'messages-notifications-control'} isDisclosureItem={true} title={'Messages'} itemCount={unreadMessages.length} disabled={false} startOpen={true}>
            {unreadMessages.map(message => {
                return (
                    <ListItem isDisclosureItem={true} className={'ch-link'} key={message.messageId} onClick={handleClick}>
                        {message.subject}
                    </ListItem>
                )
            })}
        </ListGroup>
    )
}

export default MessagesNavigation;